export default "__VITE_ASSET__27e92fcd__"